<script lang="ts">
  import type {Poem} from '../../types'
  import {t} from '../../i18n'
  import {user} from '../../stores/user'

  export let poem: Poem
</script>

<div>
  {#if poem.image_url}
    <div class="poem-cover" style="background-image: url({poem.image_url});"></div>
  {/if}
  <div class="poem-card poem-preview{!poem.image_url ? ' simple' : ''}">
    <div class="poem__actions">
      <span>{t.languages[poem.language_code as keyof typeof t.languages] || poem.language_code}</span>
    </div>
    <div class="poem__text">
      <h2>{poem.title}</h2>
      <p>{@html poem.content}</p>
    </div>
    <div class="poem__date italic">{poem.written_from}</div>
  </div>
</div>
